import React from 'react';
import Products from './Products'
import { useDispatch, useSelector } from 'react-redux';
import ABout from './ABout';
import Contact from './Contact';
import Footer from './Footer';
import { AddItem } from '../redux/Slice/foodSlice';



const Homepage = () => {

    const disp = useDispatch()
    const a = useSelector(state => state.food.cart)


    return (

        <div className='container-fluid' style={{ width: '90%', margin: '1vh auto', }}>
            <div className='row' style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>

                {/* ==== cover ===== */}

                <div className='col-md-6 col-sm-10' style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div>
                        <span style={{ color: 'red', fontSize: '1.4rem' }}>Start ordering food with</span> <span style={{ color: 'green', fontSize: '1.4rem', marginBottom: '1rem' }}> trust and belief </span>
                        <p style={{ color: 'black', fontSize: '.85rem' }}>Shopping is an activity in which a customer browses the available goods or services presented by one or more retailers with the potential intent to purchase a suitable selection of them.</p>

                    </div>
                </div>

                <div className='col-md-6 col-sm-10' style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '1rem'
                }}>
                    <img src='../images/cover.jpg' className='img-fluid cover' />
                </div>
            </div>
            <hr />
            <div className='row mt-5 '>
                <span style={{ textAlign: 'center', height: '50px', marginBottom: '1rem', fontSize: '1.2rem' }}>order food and make you & your family & your friends happy</span>



            </div>

            <div className='row'>
                {Products.map((ele, index) => {
                    return (
                        <div class="card" style={{ width: "18rem", height: 'auto', marginLeft: '2.5rem', marginBottom: '.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                            <img src={ele.image} style={{ height: '250px', objectFit: 'cover', borderRadius: '.7rem' }} class="card-img-top" alt="..." />

                            <div class="card-body">
                                <h5 class="card-title" style={{ height: '50px' }}>{ele.name}</h5>
                                <p class="card-text" style={{ fontSize: '.8rem', height: '50px' }}>{ele.description}</p>
                                <p class="card-text" style={{ height: '20px' }}>Price : ₹{ele.price}</p>

                                <p class="card-text" style={{ height: '20px' }}>Rating  :&nbsp;
                                    <span class="fa fa-star" style={{ color: 'orange' }}></span>
                                    <span class="fa fa-star" style={{ color: 'orange' }}></span>
                                    <span class="fa fa-star" style={{ color: 'orange' }}></span>
                                    <span class="fa fa-star" style={{ color: 'orange' }}></span>
                                    <span class="fa fa-star" style={{ color: 'orange' }}></span>
                                </p>

                                <button style={{ width: '220px' }}
                                    onClick={() => disp(AddItem(ele))}
                                    type="submit" className="btn btn-primary">
                                    add to cart
                                </button>
                            </div>
                        </div>
                    )
                })}
            </div>
            <hr />
            <a name='aboutme'>
                <ABout />
            </a>
            <hr />
            <a name='contactme'>
                <Contact />
            </a>


            <Footer />
        </div>
    )
}

export default Homepage;